import getApiClient from '@/plugins/api'

export default {
  checkAccess: function () {

  },

  loadData: function () {
    const self = this,
      api = getApiClient(self.$store),
      isAdmin = self.$store.state.user.roles.includes('ROLE_ADMIN')

    if (!self.$store.state.user.agency && !isAdmin) {
      return
    }

    self.$store.commit('startLoading')
    if (!isAdmin) {
      api.get(`/users/me`)
        .then(response => {
          if (response.data.agency.terms.length) {
            this.termsOfUse = response.data.agency.terms.slice(-1).pop()
            self.agencyId = response.data.agency.id
          }
        })
        .catch(error => {
          console.log(error)
        })
        .finally(() => {
          self.$store.commit('stopLoading')
        })
    } else {
      api.get('terms?company=true&itemsPerPage=1')
        .then(response => {
          if (response.data['hydra:member'].length) {
            this.termsOfUse = response.data['hydra:member'][0]
          }
        })
        .catch(error => {
          console.log(error)
        })
        .finally(() => {
          self.$store.commit('stopLoading')
        })
    }
  },

  updateTerms: function () {
    const self = this,
      api = getApiClient(self.$store),
      isAdmin = self.$store.state.user.roles.includes('ROLE_ADMIN')

    self.$store.commit('startLoading')
    self.termsSuccess = false
    self.termsError = false

    api.post('terms', {
      content: self.termsOfUse.content
    })
      .then((response) => {
        self.termsOfUse = response.data
        if (!isAdmin) {
          self.$store.commit('setAgencyTermsOfUse', response.data)
        }
        self.termsSuccess = true
        self.loadData()
      })
      .catch(() => {
        self.termsError = true
      })
      .finally(() => {
        self.$store.commit('stopLoading')
      })
  }
}
